import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { Collapsible } from './collapsible';
import { renderAndMountComponent } from '@wix/answers-lib';
export var createLegacyCollapsibleDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.collapsible', Collapsible.name);
    return {
        getTitle: function () { return baseDriver.find('.title').getText(); },
        isOpen: function () { return baseDriver.elem.classList.contains('open'); },
        toggle: function () { return baseDriver.find('.title-wrapper').click(); }
    };
};
export var createLegacyCollapsible = function (props) {
    var elem = renderAndMountComponent(React.createElement(Collapsible, __assign({}, props)));
    return createLegacyCollapsibleDriver(elem);
};
//# sourceMappingURL=collapsible.legacy-driver.js.map